import FixedAssetApi from '../../../api/bookkeeping/BookkeepingFixedAssetApi';
import { DEPRECIATION_METHODS } from '../../constants/bookkeeping/fixed_assets';

const state = {
  fixedAsset: {
    receive_date: null,
  },
};

const mutations = {
  setFixedAsset(state, fixedAsset) {
    let depreciationMethod = DEPRECIATION_METHODS.find(el => el.id === fixedAsset.depreciation_method);

    if (undefined !== depreciationMethod) {

    }
    {
      fixedAsset.depreciation_method = depreciationMethod;
    }
    state.fixedAsset = fixedAsset;
  },

  updateFixedAsset(state, payload) {
    state.fixedAsset = {
      ...state.fixedAsset,
      ...payload,
    };
  },
};

const actions = {
  storeFixedAsset({ state }) {
    return new Promise((resolve, reject) => {
      FixedAssetApi
        .store(state.fixedAsset)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  updateFixedAsset({ state }, { liquidationData }) {
    return new Promise((resolve, reject) => {
      FixedAssetApi
        .update({ fixedAsset: state.fixedAsset, liquidationData })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  showFixedAsset({ state, commit }, id) {
    return new Promise((resolve, reject) => {
      FixedAssetApi
        .show(id)
        .then(response => {
          commit('setFixedAsset', response.data);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  prepareFixedAssetForPrint({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      FixedAssetApi
        .prepareForPrint(data)
        .then(response => {
          commit('setFixedAsset', response.data);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  printEvidenceFixedAssets({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      FixedAssetApi
        .printEvidenceFixedAssets(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  generateInventoryNumber({ state, commit }, date) {
    return new Promise((resolve, reject) => {
      FixedAssetApi
        .generateInventoryNumber(date)
        .then(response => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  clearFixedAssetState({ commit }) {
    commit('setFixedAsset', {});
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
